// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { propTypes as MobxPropTypes } from 'mobx-react';
import DashboardConstants from 'logic/data/Izenda.DashboardConstants';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import { isNil } from 'lodash/fp';
const CopyButton = connect()(
  ({ loader, store, localization, showLabel, dashboardPart, dashboardPart: { isBackSide, reportPart, type } }) => {
    const isDashboardText = type === DashboardConstants.TILE_TYPE.text.type;
    const copyClass = classnames(
      { 'disabled-elm': isNil(reportPart) && !isDashboardText },
      { btn: !isNil(reportPart) || isDashboardText }
    );

    return (
      !isBackSide && (
        <a className={copyClass} title={localization.getText('COMMON_LABEL_COPY')} onClick={copy}>
          <i className="icon-copy" />
          {showLabel && <span>{localization.getText('COMMON_LABEL_COPY')}</span>}
        </a>
      )
    );

    function copy() {
      loader.startLoading();
      return store.copyDashboardPart(dashboardPart).finally(loader.endLoading.bind(loader));
    }
  }
);

CopyButton.propTypes = {
  store: MobxPropTypes.observableObject.isRequired,
  dashboardPart: MobxPropTypes.observableObject.isRequired
};

export default CopyButton;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.CopyButton.js